type TugasPokokItem = {
  title: string
  subItems: string[]
}

export const TUGAS_POKOK_ITEMS: TugasPokokItem[] = [
  {
    title: 'RENCANA HASIL KERJA PIMPINAN YANG DIINTERVENSI',
    subItems: [
      'Terlaksananya transformasi pengawasan akademik dan pengawasan manajerial yang tercermin dalam Rapor Pendidikan Daerah.',
    ],
  },
  {
    title: 'RENCANA HASIL KERJA PENGAWAS SEKOLAH',
    subItems: [
      'Terlaksananya supervisi akademik satuan pendidikan dalam mewujudkan pembelajaran yang bermutu untuk semua.',
      'Terlaksananya audit integritas kode etik guru dan kepala sekolah dalam mewujudkan pembelajaran yang bermutu untuk semua.',
      'Terlaksananya supervisi manajerial satuan pendidikan dalam mewujudkan pembelajaran yang bermutu untuk semua.',
    ],
  },
]

type TugasPokokTips = {
  url: string
  tips: string[]
}

export const TUGAS_POKOK_TIPS: TugasPokokTips = {
  url: '',
  tips: ['...', '...'],
}
